import React from 'react';

class BoostedComponent extends React.Component {
  formatCash(nb) {
    nb = Math.round(nb * 100) / 100
    let value = nb + "";
    value = value.replace(/[^0-9.,]/g, '');
    value = value.replace('.', ',');
    if (value.indexOf(',') === -1) {
      value = value + ',00 $'
    } else {
      value = value.substr(0, value.indexOf(',')) + ',' + (value.substr(value.indexOf(',')).replace(/[^0-9]/g, '') + "000").substr(0, 2) + " $"
    }
    if (value.indexOf(',') === 0) { value = "0" + value; }
    return value;
  }

  formatPhone = (tel) => {
      let erasing = (tel.substr(-1,1)==" ") ? true : false;
      tel = tel.replace(/\D/g,'');

      tel = tel.replace("-",'');
      if (tel.length > 10 && tel.substring(0,1)==="1") {
          tel = 1 +"-"+ tel.substring(1,4) + "-" + tel.substring(4,7)+"-"+tel.substring(7,11)+((tel.substring(11) && !erasing)? " #"+tel.substring(11) : '')
      } else if (tel.length > 7) {
          tel = tel.substring(0,3) + " " + tel.substring(3,6)+"-"+tel.substring(6,10)+((tel.substring(10) && !erasing)? " #"+tel.substring(10) : '')
      }  else if (tel.length > 3) {
          tel = tel.substring(0,3) + "-" + tel.substring(3,10)
      }
      return tel;
  }
  tempsStringAlt = (i) => {
    return i.replace(':', ' h ').replace(/^0/g,"");

  }
  string2temps = (e) => {
    if (e && typeof e === "string") {
      let f = e.split(':');
      return parseInt(f[0]) + parseInt(f[1])/60;
    }
    return 0;
  }
  temps2string = (e,trail = true) => {
    let secondes = e%60
    let minutes = ((e-secondes)%3600)/60
    let heures = (e - minutes*60 - secondes)/3600


 /*
    while (heures < 0) {
          console.log()
      heures += 24;
    }
*/
    secondes = (secondes < 10) ? "0"+secondes : "";
    minutes = (minutes < 10) ? "0"+minutes : minutes;
    if (trail != false) heures = (heures  < 10) ? "0"+heures  : heures;
    return heures+":"+minutes
  }
  handleInputChange = (event) => {
    const target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    if (target.type === 'tel') {
        value = this.formatPhone(value);
    }
    this.setState({
      [name]: value
    });
    window.wasModified = true;
  }
}
export default BoostedComponent;



// WEBPACK FOOTER //
// ./src/BoostedComponent.js